import Campaign from "modules/campaign/reducers";
import Contact from "modules/contact/reducers";
import Main from "modules/main/reducers";
import Payment from "modules/payment/reducers";
import Performance from "modules/performance/reducers";
import Suggestion from "modules/suggestion/reducers";
import Wizard from "modules/wizard/reducers";
import Setting from "modules/setting/reducers";
import Google from "modules/google/reducers";
import Facebook from "modules/facebook/reducers";
import Business from "modules/business/reducers";
import RCRM from "modules/rcrm/reducers";
import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

const AdProReducer = (history) =>
  combineReducers({
    campaign: Campaign,
    contact: Contact,
    main: Main,
    payment: Payment,
    performance: Performance,
    router: connectRouter(history),
    suggestion: Suggestion,
    wizard: Wizard,
    setting: Setting,
    google: Google,
    facebook: Facebook,
    business: Business,
    rcrm: RCRM,
  });

export default AdProReducer;
